import { NavigateFunction } from 'react-router-dom';

interface Props { lang: 'zh' | 'en'; navigate: NavigateFunction; }

export default function MallFooterSection({ lang, navigate }: Props) {
  return (
    <footer className="py-16 px-6 relative z-10" style={{ background: 'linear-gradient(180deg, #010208 0%, #020510 100%)', borderTop: '1px solid rgba(255,215,0,0.1)' }}>
      <div className="max-w-[1800px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'linear-gradient(135deg, rgba(255,215,0,0.2), rgba(255,107,53,0.2))', border: '2px solid rgba(255,215,0,0.4)' }}>
                <i className="ri-store-3-line text-lg" style={{ color: '#FFD700' }} />
              </div>
              <div>
                <div className="font-black text-base" style={{ fontFamily: 'Orbitron, sans-serif', color: '#FFD700' }}>NEXUS OMNI MALL</div>
                <div className="text-xs" style={{ color: 'rgba(255,215,0,0.4)' }}>{lang === 'zh' ? '星际元宇宙商城 · 购未来，在星际' : 'Interstellar Metaverse Commerce'}</div>
              </div>
            </div>
            <p className="text-white/35 text-sm leading-relaxed max-w-sm mb-4">{lang === 'zh' ? '全球首个星际元宇宙商城，汇聚500+未来商品，20大品类分区，提供VR/AR/裸眼3D沉浸购物体验，无人机+AETHER GLOBE星际物流，月球火星实时画面。' : "Earth's first interstellar metaverse mall — 500+ future products, 20 category zones, VR/AR/3D immersive shopping, drone + AETHER GLOBE logistics, Moon and Mars live feeds."}</p>
            <div className="flex gap-3">
              {['ri-twitter-x-line', 'ri-discord-line', 'ri-telegram-line', 'ri-youtube-line'].map((icon, i) => (
                <div key={i} className="w-9 h-9 rounded-xl flex items-center justify-center cursor-pointer transition-all hover:scale-110" style={{ background: 'rgba(255,215,0,0.08)', border: '1px solid rgba(255,215,0,0.2)' }}>
                  <i className={`${icon} text-sm`} style={{ color: '#FFD700' }} />
                </div>
              ))}
            </div>
          </div>
          {[
            { title: lang === 'zh' ? '快速导航' : 'Quick Nav', links: [
              { l: lang === 'zh' ? '商城介绍' : 'About Mall', h: '#intro' },
              { l: lang === 'zh' ? '20大分区' : '20 Zones', h: '#zones' },
              { l: lang === 'zh' ? '购物指引' : 'Shopping Guide', h: '#guide' },
              { l: lang === 'zh' ? '精选商品' : 'Featured', h: '#featured' },
              { l: lang === 'zh' ? '星际物流' : 'Logistics', h: '#logistics' },
            ]},
            { title: lang === 'zh' ? '特色体验' : 'Experiences', links: [
              { l: 'Google Earth', h: '#earth' },
              { l: lang === 'zh' ? '月球实时画面' : 'Moon Live Feed', h: '#space' },
              { l: lang === 'zh' ? '火星实时画面' : 'Mars Live Feed', h: '#space' },
              { l: lang === 'zh' ? '全部商品' : 'All Products', h: '/omniverse-mall/products' },
              { l: lang === 'zh' ? '返回META66' : 'Back to META66', h: '/' },
            ]},
          ].map((col, i) => (
            <div key={i}>
              <h4 className="text-white font-bold text-sm mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>{col.title}</h4>
              <div className="flex flex-col gap-2">
                {col.links.map(link => (
                  <a key={link.l} href={link.h} className="text-white/35 text-sm hover:text-white/70 transition-colors cursor-pointer">{link.l}</a>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-between pt-8" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <p className="text-white/25 text-xs">{lang === 'zh' ? '© 2026 NEXUS OMNI MALL · META66 · 星际元宇宙商城 · 购未来，在星际' : '© 2026 NEXUS OMNI MALL · META66 · Interstellar Metaverse Commerce'}</p>
          <button onClick={() => navigate('/')} className="flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-bold cursor-pointer whitespace-nowrap transition-all hover:scale-105 mt-4 sm:mt-0" style={{ background: 'rgba(255,215,0,0.08)', border: '1px solid rgba(255,215,0,0.25)', color: '#FFD700' }}>
            <i className="ri-arrow-left-line" />{lang === 'zh' ? '返回META66' : 'Back to META66'}
          </button>
        </div>
      </div>
    </footer>
  );
}
